import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';

const ExcelExport = (
  component,
  fileName = '다운로드.xlsx',
  sheetName = 'sheet1'
) => {
  const workbook = new ExcelJS.Workbook();

  exportDataGrid({
    worksheet: workbook.addWorksheet(sheetName),
    component: component,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], { type: 'application/octet-stream' }),
        fileName
      );
    });
  });
};

export { ExcelExport };
